<template>
  <div class="card">
    <div class="card section">
      <div class="card-content">
        <ul v-for="item in feedbackItems">
          <li v-if="item.type === 'YESNO'" :key="item._id">
            <label v-if="item.isMandatory" class="label required label-style">{{ item.description }}</label>
            <label v-else class="label label-style">{{ item.description }}</label>
            <label class="radio button  is-buttonYes">
              <input type="radio" v-model="feedbackResponse[item._id]" value="Yes" class="">
              <span class="icon is-large is-marginless">
                <font-awesome-icon icon="thumbs-up" />
              </span>
            </label>
            <label class="radio button is-buttonNo">
              <input type="radio" v-model="feedbackResponse[item._id]" value="No" class="">
              <span class="icon is-large is-marginless">
                <font-awesome-icon icon="thumbs-down" />
              </span>
            </label>
          </li>
          <li v-if="item.type === 'STAR5'" :key="item._id">
            <label v-if="item.isMandatory" class="label required label-style">{{ item.description }} </label>
            <label v-else class="label label-style">{{ item.description }} </label>
          <!-- <rating-field  v-model="feedbackResponse[item._id]" class=""></rating-field>-->
          <star-rating star-size=35 active-color = "#09f" :show-rating="false" v-model="feedbackResponse[item._id]" class=""> </star-rating>
          </li>
          <li v-if="item.type === 'TEXT'" :key="item._id">
            <label v-if="item.isMandatory" class="label required label-style">{{ item.description }}</label>
            <label v-else class="label label-style">{{ item.description }}</label>
            <textarea class="textarea" :placeholder="item.description"
              v-model.lazy="feedbackResponse[item._id]"></textarea>
          </li>
          <li v-if="item.type === 'PICKER' && !item.allowMultiple" :key="item._id">
            <label v-if="item.isMandatory" class="label required label-style">{{ item.description }}</label>
            <label v-else class="label label-style">{{ item.description }}</label>
            <div class="select is-small single-Select">
              <select v-model="feedbackResponse[item._id]">
                <option v-for="option in item.options" :key="option" :value="option">{{ option }}</option>
              </select>
            </div>
          </li>
          <li v-if="item.type === 'PICKER' && item.allowMultiple" :key="item._id">
            <label v-if="item.isMandatory" class="label required label-style">{{ item.description }}</label>
            <label v-else class="label label-style">{{ item.description }}</label>
            <div class="select is-small is-multiple w-100">
              <select multiple v-model="feedbackResponse[item._id]" class="w-100">
                <option v-for="option in item.options" :key="option" :value="option">{{ option }}</option>
              </select>
            </div>
          </li>
        </ul>
      </div>
      <div class="buttons are-medium is-centered margin-5 padding-5">
        <a class="button is-link" v-on:click="submitFeedbackResponse">Submit</a>
      </div>
      <footer v-if="errors.length > 0" class="mt-5 sticky has-backgroud-white">
        <UiNotification
             v-if="this.displayNotification"
             v-on:closeNotification="closeNotification"
              cls="is-danger"
              msg="All fields marked with an asterisk(*) are required"
              fade="true"
              closable="true"
            ></UiNotification>
        </footer>
    </div>
  </div>
</template>

<script>
import RatingField from '@/components/ux/RatingField';
import StarRating from 'vue-star-rating';
import Util from "@/util";
import UiNotification from "@/views/common/Notification";

export default {
  name: 'FeedbackStepper',
  props: ['campaignData'],
  components: {
    RatingField,
    StarRating,
    UiNotification
  },
  data () {
    return {
      question: -1,
      feedbackResponse: {},
      errors: {},
      displayNotification: false
    }
  },
  watch: {
    feedbackResponse: {
      handler: function (item) {
        if (this.question < (this.feedbackItems.length - 1)) {
          if (this.field && (this.field.type === 'TEXT' || (this.field.type === 'PICKER' && this.field.allowMultiple))) {
            return false;
          }
          this.next()
        }
      },
      deep: true
    },
    campaignData: function (newValue) {
      this.updateFeedbackResponse(newValue)
    }
  },
  computed: {
    feedbackItems () {
      if (this.campaignData && this.campaignData.campaign) {
        return this.campaignData.campaign.feedbackItems
      }
      return []
    },
    field () {
      return this.feedbackItems[this.question]
    }
  },
  methods: {
    updateFeedbackResponse (campaignData) {
      if (!campaignData || !campaignData.campaign) {
        return
      }
      this.feedbackResponse = campaignData.campaign.feedbackItems.reduce((map, obj) => {
        if (obj.type === 'PICKER' && obj.allowMultiple) {
          map[obj._id] = []
        } else {
          map[obj._id] = null
        }
        return map
      }, {})
    },

    submitFeedbackResponse () {
      this.validateForm()
      if (Object.keys(this.errors).length === 0) {
        if (!this.campaignData.customer) {
          this.$emit('customerinfo', this.feedbackResponse)
        } else {
          this.$emit('submit', this.feedbackResponse)
        }
      }
    },

    next () {
      this.question++
    },

    prev () {
      this.question--
    },

    validateForm() {
      this.errors = []
      console.log(this.feedbackItems)
      console.log(this.feedbackResponse)
      this.feedbackItems.forEach((item) => {
        if (item.isMandatory) {
          if (Util.isEmpty(this.feedbackResponse[item._id])) {
            this.errors.push({ field: item.description, msg: 'Please fill all mandatory fields' });
          }
        }
      })
      if (Object.keys(this.errors).length > 0) {
        this.displayNotification = true;
      }
    },
    closeNotification() {
      this.displayNotification = false;
    }
  }
}
</script>
<style scoped>
  .radio-button{
    -webkit-appearance: none;
  }
  .label-style{
    margin: 25px 0;
  }
  .is-buttonYes {
     background-color: transparent;
    color: #48c774;
  }
  .is-buttonNo {
     background-color: none;
    color: #fbca09;
  }
  .select.is-small {
    border-radius: 2px;
    font-size: 0.85rem;
  }
  .required:after {
        content: '*';
        color: rgb(199, 8, 8);
        padding-left: 5px;
        font-weight:bold;
    }
</style>
